<template>
    <PageWrapper main-max-width="max-w-10xl">
        <template #headline>
            <fa icon="fa-solid fa-list-check" />&nbsp;{{ $t('tasks') }}
        </template>
        <TasksTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import TasksTable from '@src/partials/tasks/TasksTable.vue'
</script>

<style scoped></style>
